export default {
  type: 'select',
  name: 'booleanField', // This should be overridden
  label: 'global.text.select', // This should be overridden
  locale: true,
  allowClear: true,
  options: [
    {
      label: 'global.text.yes',
      value: 'true',
    },
    {
      label: 'global.text.no',
      value: 'false',
    },
  ],
};
